import React from 'react';

import { makeStyles } from '@material-ui/styles';
import {
    MenuItem
} from '@material-ui/core';

import SelectTextField from '../SelectTextField';
import FilterLabel from './FilterLabel';
import { filterPropTypes } from '../../../../utility/prop_types/CriteriaPropType';

function SelectFilter ({ tree, field, onChange, onClear }) {
    const classes = useStyles();

    function handleChange (event) {
        if (event.target.value === '') {
            onClear(tree.id);
        } else {
            const newTree = { ...tree };
            newTree.properties = {
                ...newTree.properties,
                operator: '==',
                [event.target.name]: event.target.value
            };
            if(newTree.properties?.layer === undefined) newTree["isValid"] = false;
            if(newTree.properties?.layer !== undefined) newTree["isValid"] = true;
            onChange(newTree);
        }
    }

    function any () {
        return <div className={classes.any}>Any</div>;
    }

    return (
        <div className={classes.root}>
            <FilterLabel field={field} />
            <SelectTextField
                name="value"
                value={tree.properties.value || ''}
                onChange={handleChange}
                SelectProps={{
                    displayEmpty: true,
                    renderValue: (tree.properties.value || '') !== ''
                        ? undefined
                        : any
                }}
            >
                <MenuItem classes={{ root: classes.clear }} value="" />
                { field.settings.listOptions.map(el => <MenuItem key={el.value} value={el.value}>{el.label || el.value}</MenuItem>) }
            </SelectTextField>
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        '&> *:not(:last-child)': {
            marginRight: 10
        },
        '&> div': {
            flexGrow: 1
        }
    },
    any: {
        color: '#a9a9a9'
    },
    clear: {
        height: 36
    }
}));

SelectFilter.propTypes = filterPropTypes;

export default SelectFilter;